// @flow
import * as React from 'react'

import MenuItem from '@material-ui/core/MenuItem'
import FormControl from '@material-ui/core/FormControl'
import { FormHelperText } from '@material-ui/core'
import { ArrowDropDown, Clear, Done } from '@material-ui/icons'
import SelectM from '@material-ui/core/Select'
import makeStyles from '@material-ui/styles/makeStyles'
import Chip from '@material-ui/core/Chip'
import Checkbox from '@material-ui/core/Checkbox'
import Tooltip from '@material-ui/core/Tooltip'

import CustomLabel from './CustomLabel'

import { formattedMessage } from '../CurrentLocale'

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    margin: '1.7vh 0 0 0',
  },
  input: {
    marginTop: 1,
  },

  chip: {
    margin: 2,
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  selectAll: {
    fontWeight: 'bold',
    fontStyle: 'italic',
    textDecorationLine: 'underline',
  },
  formHelperText: {
    color: '#FF3755',
    fontSize: '9px',
    /* accessibilité : permet de zoomer les messages d'erreur UI car petite taille en maquette */
    '&:active': {
      transform: 'scale(1.5)',
      margin: '0 auto',
    },
  },
})

type Props = {
  optionsList?: Array<Object>,
  label?: string,
  handleSelectValue?: Function,
  style?: Object,
  selectedValue?: any,
  children?: any,
  inputError?: boolean,
  inputValid?: boolean,
  errorDescription?: string,
  multiple?: boolean,
  testId?: string,
  mainStyle?: {},
  mainClassname?: string,
}
//@FIXME: override MuiSelect icon (custom component ?)
const ValidStateIcon: React.ComponentType<any> = ({
  inputValid,
  inputError,
}: {
  inputValid: boolean,
  inputError: boolean,
}) => {
  if (inputValid || inputError) {
    if (!!inputError) return <Clear style={{ color: '#FF3755' }} />
    else return <Done style={{ color: '#51b03a' }} />
  } else {
    return <ArrowDropDown />
  }
}

const Select = ({
  selectedValue = '',
  optionsList = [],
  label = '',
  handleSelectValue = (noop) => noop,
  children = '',
  inputError = false,
  inputValid = false,
  errorDescription = '',
  multiple = false,
  style = {},
  mainStyle = {},
  mainClassname = '',
  testId = 'TextInputTester',
  ...MuiSelectProps
}: Props) => {
  const classes = useStyles()

  const nbElementSelect = optionsList.filter((i) => selectedValue.includes(i._id)).length

  return (
    <div className={classes.container} style={mainStyle}>
      {!!label && <CustomLabel htmlFor="custom-select">{label}</CustomLabel>}
      <FormControl style={style} className={mainClassname}>
        <div className={classes.input}>
          <SelectM
            //IconComponent={<ArrowDropDown/>}
            multiple={multiple}
            renderValue={() => {
              const filteredOptions = optionsList.filter((i) => selectedValue.includes(i._id))

              if (!!multiple) {
                if (!optionsList || optionsList.length === 0 || nbElementSelect === 0) {
                  return null
                }
                return (
                  <div className={classes.chips}>
                    {filteredOptions.map(
                      (value, index) =>
                        index < 2 && (
                          <Chip key={index} label={value.name} className={classes.chip} />
                        )
                    )}
                    {filteredOptions.length > 2 && (
                      <Tooltip
                        title={filteredOptions.map(
                          (value, index) =>
                            index >= 2 &&
                            `${value.name} ${index !== filteredOptions.length - 1 ? ', ' : ''}`
                        )}
                      >
                        <Chip className={classes.chip} label="..." />
                      </Tooltip>
                    )}
                  </div>
                )
              } else
                return optionsList
                  .filter((i) => selectedValue.includes(i._id))
                  .map((value) => value.name)
            }}
            value={selectedValue}
            onChange={(selected) => {
              if (
                selected !== null &&
                selected.target.value.length > 0 &&
                selected.target.value[selected.target.value.length - 1] === '*'
              ) {
                handleSelectValue([
                  ...selected.target.value.filter((i) => i !== '#' && i !== '*'),
                  ...optionsList.map((i) => i._id),
                ])
              } else if (
                selected !== null &&
                selected.target.value.length > 0 &&
                selected.target.value[selected.target.value.length - 1] === '#'
              ) {
                handleSelectValue(
                  selected.target.value.filter((i) => !optionsList.map((i) => i._id).includes(i))
                )
              } else {
                handleSelectValue(selected.target.value)
              }
            }}
            data-testid={testId}
            {...MuiSelectProps}
          >
            {!!multiple && optionsList.length > 0 ? (
              <MenuItem
                className={classes.selectAll}
                value={optionsList.length === nbElementSelect ? '#' : '*'}
                key={'*'}
              >
                {optionsList.length === nbElementSelect
                  ? formattedMessage({ id: 'notSelectAll' })
                  : formattedMessage({ id: 'selectAll' })}
              </MenuItem>
            ) : (
              <MenuItem value="">
                <em> </em>
              </MenuItem>
            )}

            {optionsList.map((item) => (
              <MenuItem value={item._id} key={item._id}>
                {!!multiple && <Checkbox checked={selectedValue.indexOf(item._id) > -1} />}
                {item.name}
              </MenuItem>
            ))}
            {children}
          </SelectM>
        </div>
      </FormControl>
      {!!inputError && !!errorDescription && (
        <FormHelperText className={classes.formHelperText}>{errorDescription}</FormHelperText>
      )}
    </div>
  )
}
export default Select
